import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default API => ({
  state: {
    windows: {},
    playerWindows: {},
    header: {
      extraTitle: '',
      subTitle: '',
      counter: '',
      downloadLink: '',
      traderMode: false
    },
    filters: {
      isFiltersDisabled: false
    },
    popAside: {
      transform: '',
      title: '',
      component: '',
      data: null
    },
    events: {
      sportEvents: [],
      defaultEvents: []
    },
    isMobile: false,
    notificationsQueue: []
  },
  actions: actions(API),
  mutations,
  getters
})
